<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div class="payOrderDiv">
    <ul class="payOrderBox" v-for="(item,index) in list" :key="index">
      <li v-if="item.OrderPresale==1">
        <span v-if="item.PayStage==1">定金</span>
        <span v-if="item.PayStage==2">尾款</span>
      </li>
      <li>户号：<span>{{item.TransferAccount}}</span></li>
      <li>户名：<span>{{item.TransferCompany}}</span></li>
      <li>开户行：<span>{{item.TransferMethod}}</span></li>
      <li>流水号：<span>{{item.TransferJournal}}</span></li>
      <li class="OrderPayVouchers">
        转账记录凭证
        <el-image :src="item.OrderPayVouchers[0]" fit="fit" :preview-src-list="item.OrderPayVouchers"></el-image>
      </li>
    </ul>
    </div>
  </el-dialog>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: 'payOrder',
  components: {
  },
  data() {
    return {
      dialogClass: 'payOrder',
      list:'',
      Count:0,
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
    infoList: {}
  },
  filters: {
  },
  created() {

      console.log(this.infoList)
      this.getOrderTransfer()
  },
  mounted() {
  },
  methods: {
    getOrderTransfer(){
      let that=this
      let data={id:that.infoList._id}
      that.$get(that.$interface.GetOrderTransferById,data).then(res=>{
        if(res.Result!=0){
          if(res.Count>1){
            that.Count=res.Count
            that.dialogClass='payOrder big'
          }
          that.list=res.Data
        }else{}
      })
    },
    // 关闭
    closeDialog(val) {
      this.$emit('closeDialog', 'payOrder', false)
    },
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dialog/payorder.vue